import { api } from '@/_api'

export const channel = {
  namespaced: true,
  state: {
    main: [],
    list: [],
    types: [],
    current: ''
  },
  mutations: {
    set(state, channel_id) {
      state.current = channel_id
    },
    add(state, channel) {
      state.list.unshift(Object.assign({}, channel))
    },
    edit(state, channel) {
      let idx = state.list.findIndex((el, i, arr) => el.id == channel.id)
      state.list.splice(idx, 1, Object.assign({}, channel))
    },
    remove(state, id) {
      let idx = state.list.findIndex((el, i, arr) => el.id == id)
      state.list.splice(idx, 1)
    }
  },
  actions: {
    setCurrentChannel({ commit, dispatch }, channel_id) {
      commit('set', channel_id)
      dispatch('subscribe/set', channel_id, { root: true })
      dispatch('charge/set', channel_id, { root: true })
    },
    add({ commit }, { item, callback }) {
      api.channel.create(item).then((d) => {
        if (callback(d))
          commit('add', d)
      })
    },
    edit({ commit }, { item, callback }) {
      api.channel.update(item).then((d) => {
        if (callback(d))
          commit('edit', d);
      })
    },
    remove({ commit }, { id, callback, error }) {
      api.channel.remove(id).then(() => {
        commit('remove', id);
        callback();
      }).catch(e => error(e))
    }
  },
  getters: {
    channels: state => {
      if (state.list.length == 0)
        api.channel.list()
            .then(data => state.list = data);
      return state.list;
    },
    main: state => {
      if (state.main.length == 0)
        api.channel.main()
            .then(data => state.main = data);
      return state.main;
    },
    types: state => {
      if (state.types.length == 0)
        api.channel.types()
            .then(data => state.types = data);
      return state.types;
    },
    channel: state => {
      return state.main.find(c => c.id == state.current)
    },
    getChannel: state => {
      return state.main.find(c => c.id == state.current)
    },
  }
}